import { ArrowLeft, LooksTwo } from "@mui/icons-material";
import { Box, styled, Typography } from "@mui/material";
import { COLORS } from "../../../ui/Theme";
import LooksOne from "@mui/icons-material/LooksOne";
import { ListDivider } from "../../../ui/ListStyles";
const Caption = styled("p")({
  fontSize: "12px",
  color: COLORS.GRAY,
  display: "flex",
  alignItems: "center",
  gap: "8px",
});
const DomesticMarketSpreadPriceFavoriteProducerCard = ({ favorite }) => {
  const { company1, group1, commodity1, company2, group2, commodity2 } =
    favorite;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap",
        gap: "8px",
      }}
    >
      <Box>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 700,
            display: "flex",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          <LooksOne sx={{ fontSize: "16px", color: COLORS.BLUE }} />
          {company1}
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: "8px",
          }}
        >
          <Caption>
            {group1}
            {commodity1 && <ArrowLeft />}
          </Caption>

          <Caption>{commodity1}</Caption>
        </Box>
      </Box>
      <ListDivider />
      <Box>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 700,
            display: "flex",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          <LooksTwo sx={{ fontSize: "16px", color: COLORS.BLUE }} />
          {company2}
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: "8px",
          }}
        >
          <Caption>
            {group2}
            {commodity2 && <ArrowLeft />}
          </Caption>

          <Caption>{commodity2}</Caption>
        </Box>
      </Box>
    </Box>
  );
};

export default DomesticMarketSpreadPriceFavoriteProducerCard;
